.editor {
    position: relative;
    min-height: 200px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    padding: 12px;
    font-family:
        -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
        Arial, sans-serif;
    line-height: 1.5;
}

.editor:focus-within {
    border-color: #1890ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.editor.readonly {
    background-color: #f5f5f5;
    border-color: #d9d9d9;
}

.editor.hideHelpText .helpText {
    display: none;
}

.content {
    min-height: 150px;
    outline: none;
}

.content p {
    margin: 0 0 1em 0;
}

.content p:last-child {
    margin-bottom: 0;
}

.content h1,
.content h2,
.content h3,
.content h4,
.content h5,
.content h6 {
    margin: 1.5em 0 0.5em 0;
    font-weight: 600;
}

.content h1:first-child,
.content h2:first-child,
.content h3:first-child,
.content h4:first-child,
.content h5:first-child,
.content h6:first-child {
    margin-top: 0;
}

.content ul,
.content ol {
    margin: 1em 0;
    padding-left: 2em;
}

.content li {
    margin: 0.25em 0;
}

.content table {
    border-collapse: collapse;
    width: 100%;
    margin: 1em 0;
}

.content table td,
.content table th {
    border: 1px solid #ddd;
    padding: 8px 12px;
    text-align: left;
}

.content table th {
    background-color: #f5f5f5;
    font-weight: 600;
}

.content img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 1em 0;
}

.content a {
    color: #1890ff;
    text-decoration: none;
}

.content a:hover {
    text-decoration: underline;
}

.content mark {
    background-color: #fff3cd;
    padding: 0.1em 0.2em;
    border-radius: 2px;
}

.content strong {
    font-weight: 600;
}

.content em {
    font-style: italic;
}

.content u {
    text-decoration: underline;
}

.content sub {
    vertical-align: sub;
    font-size: smaller;
}

.content sup {
    vertical-align: super;
    font-size: smaller;
}

.loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.loadingSpinner {
    width: 24px;
    height: 24px;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #1890ff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
